// extracted by mini-css-extract-plugin
export var button = "addToCartTireButton-module--button--N3T5k";
export var ajouter = "addToCartTireButton-module--ajouter--C1NzD";